
import {throwError as observableThrowError,  Observable } from 'rxjs';

import {catchError, map} from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { AuthHttp } from 'app/admin/services/token.service';
import { AppConfigService } from 'app/shared/services/app.config.service';



let AppConstant: any = {};

@Injectable()
export class DashboardService {

  constructor(private http: AuthHttp, private appConfigService: AppConfigService) { 
    AppConstant = appConfigService;
  }
  loanApplicationBysector(data) {
    return this.http.post(`dashboard/loan-application-sector`,data).pipe(
        map((res: any) => res),
        catchError((error: any) => observableThrowError(error.error || 'Server error')),);
}
loanRiskByExposure(data) {
  return this.http.post(`dashboard/loans-risk-exposure`,data).pipe(
      map((res: any) => res),
      catchError((error: any) => observableThrowError(error.error || 'Server error')),);
}
loanApplicationPerformance(data) {
  return this.http.post(`dashboard/loan-performamce`,data).pipe(
      map((res: any) => res),
      catchError((error: any) => observableThrowError(error.error || 'Server error')),);
}
loanDisbursedLoan(data) {
    return this.http.post(`dashboard/disbursed-loan`,data).pipe(
        map((res: any) => res),
        catchError((error: any) => observableThrowError(error.error || 'Server error')),);
  }
loansOnPipeline(data) {
  return this.http.post(`dashboard/loans-on-pipeline`,data).pipe(
      map((res: any) => res),
      catchError((error: any) => observableThrowError(error.error || 'Server error')),);
}
collateralExposure(data) {
    return this.http.post(`dashboard/collateral-exposure`,data).pipe(
        map((res: any) => res),
        catchError((error: any) => observableThrowError(error.error || 'Server error')),);
  }

  approvedLoan(data) {
    return this.http.post(`dashboard/approved-loan`,data).pipe(
        map((res: any) => res),
        catchError((error: any) => observableThrowError(error.error || 'Server error')),);
  }
  totalRiskExposure(data) {
    return this.http.post(`dashboard/risk-exposure`,data).pipe(
        map((res: any) => res),
        catchError((error: any) => observableThrowError(error.error || 'Server error')),);
  }

  getCountryCurrency() {
    return this.http.get(`dashboard/get-country-currency`).pipe(
        map((res: any) => res),
        catchError((error: any) => observableThrowError(error.error || 'Server error')),);
  }
}
